import { IErrorTemplateModule } from 'tag/ts/tag/interfaces/config/error/IErrorTemplateModule';

export const errorCodeToken: string = '{ERROR_CODE}';

/**
 * @description Error templates
 */
export const ErrorTemplate: IErrorTemplateModule = {
	error: '<br><br>Error Code: {ERROR_CODE}'
};